import { appConfig } from 'config/customization';

export default {
  icon: {
    color: appConfig.colors.socialRateBlue,
    paddingRight: 10,
    fontSize: 35
  },
  link: {
    textDecoration: 'none'
  },
  contactItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 15
  },
  phoneContact: {
    display: 'flex',
    flexDirection: 'column'
  }
};
